<div
  fxLayout="column"
  fxLayoutAlign="start start"
  fxLayoutAlign.lt-md="start center"
>

  <img
    [src]="logoUrl$ | async"
    class="logo-f"
    alt="logo tekkeys"
    routerLink="/"
  />

  <ul style="padding-left: 0;">
    <div *ngIf="parameter$ | async as parameter">
      <p class="description">
        {{ parameter.description }}
      </p>
    </div>
  </ul>

  <app-footer-social-links fxHide.gt-md></app-footer-social-links>
</div>
